import React from 'react';
import {
  Select,
  SelectProps,
} from '../../../../../../../../CommonComponents/OPL/Select/Select/Select';
import { SymbolOption, useSearchSymbolsSelect } from './useSearchSymbolsSelect';

interface Props extends SelectProps<SymbolOption, false> {
  clientId: number;
}

export const SearchSymbolsSelect = ({ clientId, ...rest }: Props) => {
  const { loadSymbols } = useSearchSymbolsSelect({ clientId });

  return <Select isAsync loadOptions={loadSymbols} {...rest} />;
};
